import { getCodeList, getData } from 'country-list';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Paper from 'components/system/Paper';
import colors from 'styles/colors';

const countryOptions = getData().map(({ code, name }) => ({ label: name, value: code }));
const countryCodeNameMapping = getCodeList();

const CustomPaper = ({ ...props }) => (
  <Paper elevation={10} {...props} />
);

const CountryAutocomplete = ({
  name, value, label, error, onChange, sx, autoComplete, ...rest
}) => (
  <Box className="autocomplete-container" sx={{ ...sx, width: 'inherit' }}>
    <InputLabel srink="true" htmlFor={name}>
      <Typography
        sx={{
          color: colors.text.secondary,
          display: 'block',
        }}
        variant="buttonSmall"
      >
        {label}
      </Typography>
    </InputLabel>
    <Autocomplete
      disablePortal
      name={name}
      options={countryOptions}
      clearIcon={null}
      isOptionEqualToValue={(option) => option.value === value} // Custom equality check
      className="autocomplete"
      value={countryCodeNameMapping[value?.toLowerCase()] || ''}
      onChange={(e, option) => {
        const newValue = option ? option.value.toLowerCase() : ''; // Handle null case
        onChange({
          target: { value: newValue.toLowerCase(), name },
          currentTarget: { value: newValue.toLowerCase(), name },
        });
      }}
      PaperComponent={CustomPaper}
      renderInput={(params) => (
        <TextField
          error={!!error}
          helperText={error}
          {...params}
        />
      )}
      autoComplete={autoComplete !== 'off'}
      {...rest}
    />
  </Box>
);

export default CountryAutocomplete;
